import { compose } from 'recompose';
import CardActivity from './cardActivity';

const enhance = compose();
export default enhance(CardActivity);
